import { useGetETSTicketNotificationsCountForChannelSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import ChatConnectionBanner from 'gcs-common/components/ChatConnectionBanner/ChatConnectionBanner';
import { BEAMER_CHANNEL_ID, BEAMER_CHANNEL_TITLE } from 'gcs-common/constants/channelConstants';
import { ICON } from 'gcs-common/constants/IconConstants';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { SidebarTrigger, useSidebar } from 'gcs-common/design-system/ui/sidebar';
import { getNumOpenTasksForChannel } from 'gcs-common/slices/channel/channelSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getCurrentUserIsMemberOfChannel } from 'gcs-common/slices/salesSpaceChannels/salesSpaceChannelsSelectors';
import { getFavicon } from 'gcs-common/slices/theme/themeSelectors';
import { getRightBarTab } from 'gcs-common/slices/uiState/uiStateSelectors';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageWithStatus from '../ImageWithStatus/ImageWithStatus';
import ChannelArchiveButton from './ChannelArchiveButton/ChannelArchiveButton';
import { ChannelDetailsButton } from './ChannelDetailsButton/ChannelDetailsButton';
import ChannelEmailPopup from './ChannelEmailPopup/ChannelEmailPopup';

function ChatNavBar() {
  const dispatch = useDispatch();
  const rightBarTab = useSelector(getRightBarTab);
  const sidebar = useSidebar();

  const selectedChannelId = useSelector(getSelectedChannelId);
  const isAgent = useSelector(getIsAgent);
  const ticketNotificationsCount = useGetETSTicketNotificationsCountForChannelSelector(selectedChannelId);
  const logo = useSelector(getFavicon);

  const isUserInCurrentChannel = useSelector(getCurrentUserIsMemberOfChannel(selectedChannelId));
  const numOpenTasks = useSelector(getNumOpenTasksForChannel(selectedChannelId));

  const rightbarNotifications = !!(ticketNotificationsCount + numOpenTasks);

  const toggleSearch = () => {
    sidebar.setOpen(true);
    if (rightBarTab === RIGHT_BAR_TABS.SEARCH) {
      dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
    } else {
      dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.SEARCH }));
    }
  };

  useEffect(() => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
  }, [selectedChannelId, dispatch]);

  if (selectedChannelId === BEAMER_CHANNEL_ID) {
    return (
      <>
        <div
          className="box-border h-[76px] flex-col content-center border-0 border-neutral-6 border-b border-solid px-4"
          data-testid="chat-nav-bar"
        >
          <div className="flex grow flex-row items-center gap-x-2 overflow-hidden rounded-xl bg-neutral-1">
            <ImageWithStatus imageUrl={logo} isSalesSpace className="m-1" isAgent={false} />
            <div className="flex flex-col justify-center overflow-hidden truncate text-left font-medium text-base">
              {BEAMER_CHANNEL_TITLE}
            </div>
          </div>
        </div>
        <ChatConnectionBanner />
      </>
    );
  }

  return (
    <>
      <div
        className="box-border h-[76px] flex-col content-center border-0 border-neutral-6 border-b border-solid px-4"
        data-testid="chat-nav-bar"
      >
        <div className="flex flex-row bg-neutral-1">
          <ChannelDetailsButton className="grow rounded-xl hover:bg-neutral-3 active:bg-neutral-4" />
          <div className="flex items-center justify-between gap-2">
            <ChannelArchiveButton selectedChannelId={selectedChannelId} />
            {isAgent && isUserInCurrentChannel && <ChannelEmailPopup />}
            <IconButton
              Icon={ICON.SEARCH}
              onClick={toggleSearch}
              iconSize="size-6"
              className="cursor-pointer"
              size="m"
              variant="ghost_neutral"
            />
            {!sidebar.open && (
              <SidebarTrigger
                onClick={() => dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }))}
                notifications={rightbarNotifications}
              />
            )}
          </div>
        </div>
      </div>
      <ChatConnectionBanner />
    </>
  );
}

export default ChatNavBar;
